import React from 'react'

const Footer = () => {
    return (
        <div className='my-10 mb-5'>
            <p className="text-xs text-center gradient-text">&copy; Kalyani Dantuluri @2024. All rights reserved.</p>
        </div>
    )
}

export default Footer